import {
  FinalHeader,
  MatchViewerTeamsTable,
  SetHeader,
  TrackHeader,
} from "./styles";
import { MatchesViewerListTeam } from "./MatchesViewerListTeam";
import { Match, getWinningRosterIds } from "model/Match/Match";
import {
  getMatchPartHeaders,
  getMatchPartScores,
  getRosterDisplayScore,
  PartHeader,
} from "model/Match/MatchScore";
import { getNumTeams } from "model/Match/MatchTeams";
import { getRosterIdOrPlaceholder } from "model/Roster/Roster";

interface Props {
  match: Match;
  tournamentId: string;
}

export const MatchesViewerTeamList = ({ match, tournamentId }: Props) => {
  if (getNumTeams(match.teams) > 10) {
    return <></>;
  }

  const matchWinnerIds = getWinningRosterIds(match);
  return (
    <MatchViewerTeamsTable>
      {getHeaderRow(getMatchPartHeaders(match))}
      {match.teams.rosters.map((roster, i) => {
        const rosterId = getRosterIdOrPlaceholder(roster);
        return (
          <MatchesViewerListTeam
            key={`${i}-${rosterId ?? roster.toString()}`}
            rosterId={rosterId}
            tournamentId={tournamentId}
            scoreString={getRosterDisplayScore(match, rosterId)}
            partScores={getMatchPartScores(match, rosterId, true)}
            isWinner={
              !matchWinnerIds
                ? undefined
                : !!rosterId && matchWinnerIds.includes(rosterId)
            }
          />
        );
      })}
    </MatchViewerTeamsTable>
  );
};

const getHeaderRow = (partHeaders: PartHeader[]) => {
  return (
    <tr>
      <th />
      <FinalHeader>F</FinalHeader>
      {partHeaders.map((h) =>
        h.type === "Set" ? (
          <SetHeader>{h.value}</SetHeader>
        ) : (
          <TrackHeader>{h.value}</TrackHeader>
        )
      )}
    </tr>
  );
};
